import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'
import main from './modules/main'
import registration from './modules/registration'
import searchestate from './modules/searchestate'
import viewestate from './modules/viewestate'
import notice from './modules/notice'
import document from './modules/document'
import recommend from './modules/recommend'
import expertmanagement from './modules/expertmanagement'
import noticemanagement from './modules/noticemanagement'
import documentmanagement from './modules/documentmanagement'
import bannermanagement from './modules/bannermanagement'
import payments from './modules/payments'
import mypage from './modules/mypage'
import mypagetest from './modules/mypagetest'
import qna from './modules/qna'
import login from './modules/login'
import adminestate from './modules/adminestate'
import itemmanagement from './modules/itemmanagement'
import adminuser from './modules/adminuser'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    common,
    main,
    registration,
    searchestate,
    viewestate,
    notice,
    document,
    recommend,
    expertmanagement,
    noticemanagement,
    documentmanagement,
    bannermanagement,
    payments,
    mypage,
    mypagetest,
    qna,
    login,
    adminestate,
    itemmanagement,
    adminuser
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js